import {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';

export type Validated<T> = T & {
	error: string | null;
};

interface ValidatableItem {
	id?: unknown;
	displayName?: string;
}

export function useOptionListValidator<T extends ValidatableItem>(options: T[]): Validated<T>[] {
	const {formatMessage} = useIntl();
	const getError = useCallback(
		(option: T) => {
			if (!option.displayName) {
				return formatMessage({
					id: 'settings.custom-fields.dropdown-options.edit_modal.dropdown_option_item.error_message',
				});
			}
			if (options.find(o => o.displayName === option.displayName && o.id !== option.id)) {
				return formatMessage({
					id: 'settings.custom-fields.dropdown-options.edit_modal.dropdown_option_item.duplicate_error_message',
				});
			}
			return null;
		},
		[options]
	);

	const validatedOptions = useMemo(() => options.map(o => ({...o, error: getError(o)})), [options, getError]);

	return validatedOptions;
}
